export function inr(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  if (!isFinite(n)) {return "₹0";}
  return "₹" + n.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function maskAadhaar(value?: string | null): string {
  if (!value) {return "-";}
  const digits = value.replace(/\D/g, "");
  if (digits.length < 4) {return value;}
  return "XXXX XXXX " + digits.slice(-4);
}

export function formatDate(value?: string | Date | null): string {
  if (!value) {return "-";}
  const d = typeof value === "string" ? new Date(value) : value;
  if (isNaN(d.getTime())) {return "-";}
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export function shortDate(value?: string | Date | null): string {
  if (!value) {return "-";}
  const d = typeof value === "string" ? new Date(value) : value;
  if (isNaN(d.getTime())) {return "-";}
  return d.toLocaleDateString("en-GB");
}

export function isValidMobile(v: string) {
  return /^[6-9]\d{9}$/.test(v.replace(/\D/g, ""));
}

export function isValidAadhaar(v: string) {
  return /^\d{12}$/.test(v.replace(/\D/g, ""));
}

export function isValidIfsc(v: string) {
  return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(v.toUpperCase());
}

export const STATUSES = [
  "Draft",
  "Profile Incomplete",
  "Ready for Letter",
  "Letter Generated",
  "Completed",
  "Cancelled",
] as const;